import type { CourseProps } from '../../types'
import type { CourseSummary } from '../pages/Dasboard/_components/types'

export const courseFallbackImages = [
  '/assets/sing-women.png',
  '/assets/girl-sing.png',
  '/assets/microphone-man.png',
]

export const getCourseFallbackImage = (index: number) =>
  courseFallbackImages[index % courseFallbackImages.length]

export const toCourseSummary = (
  course: CourseProps,
  index: number,
): CourseSummary => {
  const totalWeeks = course.material?.length ?? course.duration ?? 0
  const currentWeek = Math.min(Math.max(0, course.currentWeek ?? 0), totalWeeks)
  const progress =
    totalWeeks > 0
      ? Math.min(100, Math.round((currentWeek / totalWeeks) * 100))
      : 0
  const title = course.title?.trim() || 'Curso asignado'

  return {
    id: course.uid || `course-${index}`,
    title,
    teacher: 'Equipo Diga Ah',
    image: getCourseFallbackImage(index),
    progress,
    lessons:
      totalWeeks > 0
        ? `${currentWeek} de ${totalWeeks} semanas`
        : 'Duración por confirmar',
    level:
      progress >= 100 ? 'Completado' : progress > 0 ? 'En progreso' : 'Nuevo',
  }
}
